import { render } from "./runoff-badge.vue?vue&type=template&id=56e15730&scoped=true"
import script from "./runoff-badge.vue?vue&type=script&lang=js"
export * from "./runoff-badge.vue?vue&type=script&lang=js"

import "./runoff-badge.vue?vue&type=style&index=0&id=56e15730&scoped=true&lang=css"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56e15730"]])

export default __exports__